import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useParams } from 'react-router-dom'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { ClientView } from '../components/websiteClaims/views/singleClientView'
import { AllCases } from '../components/websiteClaims/views/subViews/clientCasesViewContainer'

function ViewWebsiteClient() {
    const [allCaseData, setAllCaseData] = useState<any>()
    const [clientData, setClientData] = useState<any>()
    const [clientID, setClientID] = useState<string>('')
    const { url_client } = useParams()

    useEffect(() => {
        if (url_client && clientID == '') {
            setClientID(url_client)
            Loading.circle('Loading...')
            // console.log("LOADING.... GET CASE DATA");
            getData(url_client)
        }
    }, [clientID])

    const getData = async (url_clientID: string) => {
        try {
            // console.log("CASEREF: ", url_case_ref);
            let payload = url_clientID
            if (url_client) {
                payload = url_client
            }
            const apiResponse = await api({
                url: 'pcp-sentinel/view-client',
                data: { client_id: payload },
            })
            const data = apiResponse.data

            if (data.success) {
                // console.log("cases: ", data.allCaseInfo.length);
                // console.log("clientInfo: ", data.clientInfo);

                setAllCaseData(data.allCaseInfo)
                setClientData(data.clientInfo)
            }

            // console.log("CASE DATA: ", data);
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response.status == 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else {
                console.log('error getting data from api....')
                // window.location.href = getLoginUrl();
            }
        }
    }

    return (
        <div className="viewCase">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Media claims client"
                        title={clientData ? `${clientData.firstname} ${clientData?.lastname}` : '\u00a0'}
                        meta={clientData?.email}
                        backTo="/media-claims"
                        backLabel="All clients"
                    />
                    {clientData ? <ClientView data={clientData} /> : null}
                    {allCaseData ? <AllCases data={allCaseData} client={clientData} requestData={getData} /> : null}
                </Page>
            </MainView>
        </div>
    )
}

export default ViewWebsiteClient
